function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import { pureTranslate } from "../Translate";
import DictionaryContext from "./DictionaryContext";

var Dictionary = function Dictionary(_ref) {
  var values = _ref.values,
      children = _ref.children;
  return React.createElement(DictionaryContext.Provider, {
    value: values
  }, children);
};

export function withDictionary(Component) {
  return function DictionaryComponent(props) {
    return React.createElement(DictionaryContext.Consumer, null, function (dictionary) {
      return React.createElement(Component, _extends({}, props, {
        translate: function translate(tKey, values) {
          return pureTranslate(dictionary, tKey, values);
        }
      }));
    });
  };
}
export default Dictionary;